var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./PromoptMessageBubble.module.scss";
import { getSettings } from "../../constants/setting";
import { isEmpty } from "lodash";
import { CHAT_BOT_POSITION_LEFT } from "../../constants";
import { interactWithChatBot } from "../../stores/reducers/chatReducer";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import { getTranslation } from "../../../embedded/constants/setting";
var PromptMessageBubble = function (props) {
    var onClickCallback = props.onClickCallback;
    var dispatch = useDispatch();
    var _b = useState(false), isBubbleClose = _b[0], setIsBubbleClose = _b[1];
    var _j = getSettings(), new_user_prompt_message = _j.new_user_prompt_message, new_user_prompt_delay = _j.new_user_prompt_delay, new_user_prompt_background_color = _j.new_user_prompt_background_color, new_user_prompt_text_color = _j.new_user_prompt_text_color;
    var _k = useState(false), showPrompt = _k[0], setShowPrompt = _k[1];
    var chat_bot_position = getSettings().chat_bot_position;
    var onCloseClicked = function (e) {
        e.preventDefault();
        e.stopPropagation();
        dispatch(interactWithChatBot());
        setIsBubbleClose(true);
    };
    useEffect(function () {
        setTimeout(function () {
            setShowPrompt(true);
        }, (new_user_prompt_delay || 1) * 1000);
    }, []);
    return _jsx(_Fragment, { children: !isEmpty(new_user_prompt_message) && _jsx(_Fragment, { children: showPrompt && !isBubbleClose && _jsxs("div", __assign({ style: {
                    backgroundColor: new_user_prompt_background_color || '#ffffff',
                    color: new_user_prompt_text_color || '#000000',
                    borderColor: new_user_prompt_background_color || '#000000',
                }, className: styles.bubblePrompt + ' ' + (chat_bot_position === CHAT_BOT_POSITION_LEFT ? styles.bubblePromptLeft : styles.bubblePromptRight), onClick: function () { return onClickCallback(); } }, { children: [_jsxs("button", __assign({}, { tabIndex: 0 }, { id: "close_chatbot_welcome_bubble", style: {
                            backgroundColor: new_user_prompt_background_color || '#ffffff',
                        }, className: styles.bubbleCloseButton, onClick: onCloseClicked }, { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: "15", height: "15", fill: new_user_prompt_text_color || '#000000' }, { children: _jsx("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" }) })), _jsx(Form.Label, __assign({ htmlFor: "close_chatbot_welcome_bubble", className: "".concat(styles.srText, " ").concat(styles.srOnly) }, { children: getTranslation('chatbot.close_chatbot_welcome_bubble') }))] })), _jsx("div", { dangerouslySetInnerHTML: { __html: new_user_prompt_message || '' } })] })) }) });
};
export default PromptMessageBubble;
